import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

export const fetchDetailProduks = async ({ page = 1, per_page = 10, filters = {} }) => {
  try {
    const validatedPage = Math.max(1, parseInt(page) || 1);
    const validatedPerPage = Math.max(1, Math.min(100, parseInt(per_page) || 10));

    // Base params
    const params = {
      page: validatedPage,
      per_page: validatedPerPage,
      ...filters   // langsung spread, jadi id_produk=2
    };

    console.log('Final API params:', params);

    const response = await axios.get(`${BASE_URL_BE}/detail-produk`, {
      headers: getAuthHeaders(),
      params: params,
      paramsSerializer: {
        indexes: null
      }
    });

    if (!response.data) {
      throw new Error('Invalid API response: missing data');
    }

    return {
      data: Array.isArray(response.data.data) ? response.data.data : [],
      meta: {
        page: response.data.meta?.page || validatedPage,
        per_page: response.data.meta?.per_page || validatedPerPage,
        total: response.data.meta?.total || 0,
        last_page: response.data.meta?.last_page || 1
      }
    };

  } catch (error) {
    console.error("Error fetching detail produk:", error);

    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        'Failed to fetch detail produk data';
    
    const apiError = new Error(errorMessage);
    apiError.status = error.response?.status;
    apiError.details = error.response?.data?.errors || {};
    
    throw apiError;
  }
};


export const createDetailProduk = async (formData) => {
  try {
    // Convert string numbers to integers
    const payload = {
      ...formData,
      id_produk: parseInt(formData.id_produk, 10)
    };

    const response = await axios.post(`${BASE_URL_BE}/detail-produk`, payload, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating detail produk:", error);
    throw error;
  }
};

export const updateDetailProduk = async (id_detail_produk, formData) => {
  try {
    // Convert string numbers to integers
    const payload = {
      ...formData,
      id_produk: parseInt(formData.id_produk, 10)
    };

    const response = await axios.put(`${BASE_URL_BE}/detail-produk/${id_detail_produk}`, payload, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating detail produk:", error);
    throw error;
  }
};

export const deleteDetailProduk = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/detail-produk/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting detail produk:", error);
    
    // Enhanced error handling
    if (error.response) {
      const apiError = new Error(error.response.data.message || 'Failed to delete detail produk');
      throw apiError;
    }
    
    throw error;
  }
};

export const getDetailProdukByID = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/detail-produk/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error getting detail produk by ID:", error);
    
    // Enhanced error handling
    if (error.response) {
      const apiError = new Error(error.response.data.message || 'Failed to get detail produk');
      throw apiError;
    }
    
    throw error;
  }
};

// Additional function to fetch details by product ID
export const fetchDetailProduksByProdukId = async (id_produk, { page = 1, per_page = 10 } = {}) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/produk/${id_produk}/detail-produk`, {
      headers: getAuthHeaders(),
      params: {
        page,
        per_page
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching detail produk by product ID:", error);
    throw error;
  }
};